export const GROUP_NAME_OPTIONS = [
  { value: "analgesicsOpiods", label: "Analgesics (Opiods)" },
  { value: "anestheticsLocal", label: "Anesthetics (Local)" },
  { value: "antacids", label: "Antacids" },
  { value: "anthelmintics", label: "Anthelmintics" },
  { value: "antibiotics", label: "Antibiotics" },
  { value: "anticoagulants", label: "Anticoagulants" },
  { value: "antidepressants", label: "Antidepressants" },
  { value: "antidiabeticsOha", label: "Antidiabetics (OHA)" },
  { value: "antiemetics", label: "Antiemetics" },
  { value: "antiepileptics", label: "Antiepileptics" },
  { value: "antifungals", label: "Antifungals" },
  { value: "antihistamines", label: "Antihistamines" },
  { value: "antihypertensives", label: "Antihypertensives" },
  { value: "antipyretics", label: "Antipyretics" },
  { value: "antisepticsDisinfectants", label: "Antiseptics / Disinfectants" },
  { value: "antivirals", label: "Antivirals" },
  { value: "bronchodilators", label: "Bronchodilators" },
  { value: "corticosteroids", label: "Corticosteroids" },
  { value: "disposablesConsumables", label: "Disposables/Consumables" },
  { value: "diuretics", label: "Diuretics" },
  { value: "enzymesDigestives", label: "Enzymes & Digestives" },
  { value: "generalItems", label: "General items" },
  { value: "implants", label: "Implants" },
  { value: "insulins", label: "Insulins" },
  { value: "laxatives", label: "Laxatives" },
  { value: "lipidLoweringAgents", label: "Lipid-Lowering Agents" },
  { value: "muscleRelaxants", label: "Muscle Relaxants" },
  { value: "nsaidAntiInflammatoryDrugs", label: "NSAID /Anti-inflammatory Drugs" },
  { value: "sedativesHypnotics", label: "Sedatives & Hypnotics" },
  { value: "vaccines", label: "Vaccines" },
  { value: "vitaminsSupplements", label: "Vitamins & Supplements" },
  { value: "sartan", label: "Sartan" },
];
